<template>
<div id="removeclass">
  <modal
    :modal-id="modalId"
    :title="modalTitle"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
  >
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="addurl"
      >
        <!-- <div class="form-group row align-items-center">
          <label class="col-sm-3 mb-0">{{ $t("document_category") }}</label>
          <app-input
            class="col-sm-9"
            type="search-select"
            :placeholder="$t('select_task_category')"
            :list="documentCategories"
            v-model="category_id"
          />
        </div> -->
        <div class="form-group row align-items-center" v-for="(input,k) in inputs" :key="k">
          <label for="inputs_qualification" class="col-sm-3 mb-0">
            {{$t("field_name") }}
          </label>
          <app-input
            id="inputs_qualification"
            class="col-sm-6"
            type="text"
            v-model="input.name"
            :required="true"
          />
          <span>
            <i class="fas fa-minus-circle" @click.prevent="remove(k)" v-show="k || ( !k && inputs.length > 1)">Remove</i>
            <i class="fas fa-plus-circle" @click.prevent="add(k)" v-show="k == inputs.length-1">Add fields</i>
          </span>
        </div>
      </form>
    </template>
  </modal>
</div>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../Mixins/ModalMixin";
import * as actions from "../../../../Config/ApiUrl";
import {
  axiosPost,
  axiosDelete,
  axiosGet,
} from "../../../../Helpers/AxiosHelper.js";
import AppLibrary from "../../../../Helpers/AppLibrary";

export default {
  name: "AddModal",
  extends: AppLibrary,
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    category_id: Number,
  },
  data() {
    return {
      documentCategories: [],
      addurl: actions.DOCUMENT_EXTRA_FIELDS_STORE,
      preloader: false,
      inputs: [{
        name: '',
      }],
      // category_id: '',
      modalId: "demo-add-edit-Modal",
      modalTitle: this.$t("add"),
    };
  },
  created() {
    if (this.selectedUrl) {
      this.modalTitle = this.$t("edit");
      // this.postUrl = actions.MYDOCUMENT_UPDATE;
      // this.preloader = true;
    }
  },
  methods: {
    add () {
      this.inputs.push({
        name: '',
      })
      
    },

    remove (index) {
      this.inputs.splice(index, 1)
    },
    submit() {
        
        let formData = new FormData();
        formData.append('category_id',this.category_id);

        let data = [];
        Object.keys(this.inputs).forEach((obj) => {
          data = [...data,this.inputs[obj]];
        });
        formData.append('extra',JSON.stringify(data));

        this.save(formData);
    },
    afterSuccess(response) {
      this.$toastr.s(response.data.message);
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      // if (response.data.phone) this.phone = response.data.phone;
      this.inputs = response.data;
      this.inputs.document_name = response.data.name;
      this.uploade_files = response.data.files;
      this.preloader = false;
    },

    deletefile(id, index) {
      this.uploade_files.splice(index, 1);
      axiosDelete(actions.UPLOADED_DOCUMENT_DELETE + "/" + id)
        .then((res) => {
          
          this.$toastr.s(res.data.message);
        })
        .catch((error) => {
          this.$toastr.e(error);
        })
        .finally(() => {});
    },
    // getdocumentCategories() {
    //   axiosGet(actions.DOCUMENT_CATEGORIES)
    //     .then((res) => {
    //       this.documentCategories = res.data;
    //     })
    //     .catch((error) => {
    //       this.$toastr.e(error);
    //     })
    //     .finally(() => {});
    // },
  },

  mounted() {
    $(function () {
      $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
    });
    // this.getdocumentCategories();
  },
};
</script>
